import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mpp-panel" }
const _hoisted_2 = { class: "mpp-header" }
const _hoisted_3 = { class: "mpp-title" }
const _hoisted_4 = { class: "mpp-tabs" }
const _hoisted_5 = { class: "mpp-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaintenanceOSTiposTab = _resolveComponent("MaintenanceOSTiposTab")!
  const _component_MaintenanceOSRealizadasTab = _resolveComponent("MaintenanceOSRealizadasTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "mpp-back",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [
          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
        ], -1),
        _createTextVNode(" Voltar ", -1)
      ]))]),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.project.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass(["mpp-tab", { active: _ctx.activeTab === 'os' }]),
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'os'))
      }, "Ordens de Serviço", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["mpp-tab", { active: _ctx.activeTab === 'realizadas' }]),
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'realizadas'))
      }, "OS realizadas", 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.activeTab === 'os')
        ? (_openBlock(), _createBlock(_component_MaintenanceOSTiposTab, {
            key: 0,
            project: _ctx.project,
            "access-level": _ctx.accessLevel
          }, null, 8, ["project", "access-level"]))
        : (_openBlock(), _createBlock(_component_MaintenanceOSRealizadasTab, {
            key: 1,
            project: _ctx.project,
            "access-level": _ctx.accessLevel
          }, null, 8, ["project", "access-level"]))
    ])
  ]))
}